<template>
  <div class="products">
    <!-- 走马灯 轮播图 -->
    <carousel-box></carousel-box>

    <div class="centerP">
      <!-- 面包屑 -->
      <div class="breadcrumbBox">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{
            productTypeName === "全部" ? $t("products.all") : productTypeName
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            {{ $t("products.totel") }}{{ productList.length
            }}{{ $t("products.piece") }}</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>

      <!-- 商品列表 -->
      <div class="productList">
        <router-link
          :to="{ name: 'productInfo', params: { goodsNo: item.goodsNo } }"
          class="productItem"
          v-for="(item, index) in productList"
          :key="index"
          v-show="item.classType != 0"
        >
          <el-image
            class="productImg"
            :src="item.diagramCode"
            fit="cover"
          ></el-image>
          <!-- <p class="productName" :title="item.goodsName" style="">
            {{ item.goodsName }}
          </p> -->
          <el-tooltip placement="top" :content="item.goodsName" effect="light"
            ><p class="productName" style="">
              {{ item.goodsName }}
            </p>
          </el-tooltip>
          <p class="goodsEnglish">{{ item.goodsEnglish }}</p>
          <p class="retailPrice" v-if="item.retailPrice">
            {{ Number(item.retailPrice).toFixed(2) }}{{ $t("products.yuan") }}
          </p>
        </router-link>

        <div class="productItem" v-if="productList.length % 4 <= 1"></div>
        <div class="productItem" v-if="productList.length % 4 <= 2"></div>
        <div class="productItem" v-if="productList.length % 4 <= 3"></div>
      </div>
    </div>
  </div>
</template>
<script>
import carouselBox from "@/components/carouselBox.vue";
import { sessionSto } from "@/util/sessionStorageManage.js";
import { getIndexGoods, getGoodsByCondition } from "@/apis/product/index.js";

import { setTitle } from "@/util/thirdPartyAdapter/baiduPromotion.js";
export default {
  name: "products",
  data() {
    return {
      productTypeName: "全部",
      parentNo: "", // 商品类型 全查值为All
      productList: [],

      maxShowGoodsNum: 400
    };
  },
  methods: {
    // 判断banner是否能跳转
    canRouter(item) {
      let flag = false;
      if (item.advType == 1) {
        flag = true;
      } else if (item.advType == 2) {
        flag = true;
      } else if (item.advType == 3 && item.advSeco != 0) {
        flag = true;
      }
      return flag;
    },

    // 点击banner
    chioseCarousel(item) {
      if (item.advType == 1) {
        this.$router.push({ name: "products", params: { no: item.classNo } });
      } else if (item.advType == 2) {
        this.$router.push({
          name: "productInfo",
          params: { goodsNo: item.goodsNo }
        });
      } else if (item.advType == 3 && item.advSeco != 0) {
        this.toNewPage(item.advInoutUrl);
      }
    },

    toNewPage(url) {
      window.open(url);
    },

    getAllProducts() {
      const data = {};
      getIndexGoods(data).then(res => {
        if (res.code != 200 && !res.data && res.data.length <= 0) {
          return;
        }
        let goodslist = []; //
        let goodIndex = 0;
        const resData = res.data;
        console.log(resData);
        goodslist = [];
        resData.forEach(item_lv1 => {
          goodIndex = 0;
          item_lv1.onlineChilds.forEach(item_lv2 => {
            item_lv2.goodsDocuments.forEach(item_lv3 => {
              if (goodIndex < this.maxShowGoodsNum) {
                goodslist.push({
                  diagramCode: item_lv3.diagramCode,
                  goodsName: item_lv3.goodsName,
                  goodsEnglish: item_lv3.goodsEnglish,
                  goodsNo: item_lv3.goodsNo,
                  goodsAlias: item_lv3.goodsAlias,
                  retailPrice: item_lv3.singles[0].retailPrice,
                  classType: item_lv1.classType
                });
              }
              goodIndex++;
            });
          });
        });

        this.productList = goodslist;
      });
    },

    getProductsBytype() {
      const data = {
        isLast: 0, // 0: 查询所有，忽略priceRange、classno； 1：依据priceRange、classno查询
        priceRange: "",
        classno: this.parentNo,
        orderBy: ""
      };
      getGoodsByCondition(data).then(res => {
        console.log(res);
        this.productList = res.data;
      });
    },

    getProductType(no) {
      let res = "";
      let list = sessionSto.$selectSession("GoodsCategory");
      if (list) {
        list = JSON.parse(list);
      }
      if (no == "NaN") {
        return list[0].name;
      }
      for (var i in list) {
        if (list[i].no === no) {
          res = list[i].name;
          break;
        }
      }
      return res;
    }
  },
  mounted() {},
  created() {
    this.parentNo = this.$route.params.no;
    if (this.parentNo === "all") {
      this.productTypeName = "全部";
      this.getAllProducts();
    } else {
      this.getProductsBytype();
      this.productTypeName = this.getProductType(this.parentNo);
    }
    const pageName = this.productTypeName;
    setTitle(pageName);
  },
  watch: {
    $route(to, from) {
      if (to.params.no === from.params.no) {
        return;
      }
      this.parentNo = this.$route.params.no;
      if (this.parentNo === "all") {
        this.productTypeName = "全部";
        this.getAllProducts();
      } else {
        this.getProductsBytype();
        this.productTypeName = this.getProductType(to.params.no);
      }
      const pageName = this.productTypeName;
      setTitle(pageName);
    }
  },
  destroyed() {},
  components: {
    carouselBox
  }
};
</script>
<style lang="less" scoped>
.products {
  padding-bottom: 30px;

  .centerP {
    width: 800px;
    margin: 0px calc(50% - 400px);

    .breadcrumbBox {
      margin: 28px 0px 30px 0px;
    }

    .productList {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .productItem {
        width: 195px;
        height: fit-content;
        text-align: left;
        margin-bottom: 50px;
        text-decoration: none;

        &:hover {
          text-decoration: revert;
        }

        .productImg {
          width: 195px;
          height: 195px;
          display: inline-block;
          border: 1px solid #e0e0e0;
          border-radius: 5px;
          overflow: hidden;
        }
        .productName {
          width: 100%;
          margin-top: 12px;
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          letter-spacing: 1px;
          color: #000000;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .goodsEnglish {
          font-family: MiSans;
          font-size: 12px;
          font-weight: normal;
          line-height: 20px;
          text-decoration: none;
          color: #6d6d6d;
        }
        .retailPrice {
          font-size: 16px;
          font-weight: bold;
          line-height: 20px;
          text-decoration: revert;
          text-align: left;
          color: #000000;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/products/index.vue